module.exports = __webpack_public_path__ + "static/media/md-code-working.2b0e1bb3.svg";